import React from "react"
import {Box, Typography} from "@mui/material"
import {packagingTokens as tk} from "@/theme/packagingTokens"

type FieldLabelProps = {
    label: React.ReactNode
    description?: React.ReactNode
    required?: boolean
}

// Consistent form field label (13.5/600) + optional secondary description.
// Replaces the old `<Typography variant="subtitle1"><b>…</b>` pattern.
export default function FieldLabel({label, description, required}: FieldLabelProps) {
    return (
        <Box sx={{mb: 1}}>
            <Typography sx={{fontSize: "13.5px", fontWeight: 600, color: tk.color.textPrimary}}>
                {label}
                {required && <Box component={"span"} sx={{color: tk.color.red, ml: 0.25}}>*</Box>}
            </Typography>
            {description && (
                <Typography sx={{fontSize: "13px", color: tk.color.textSecondary, mt: 0.25}}>
                    {description}
                </Typography>
            )}
        </Box>
    )
}
